import { createContext } from 'react'

import { IUserCanUpdateProposalContext } from './UserCanUpdateProposalContextProvider'

export const UserCanUpdateProposalContext =
  createContext<IUserCanUpdateProposalContext>({
    handleErrorBeforePingPongAction: () => ({ stopExecution: false }),
  })
